import React from 'react';
import { Badge, Typography } from 'antd';
import '../../GxP.scss';
import type { GxPReportTabKey } from '../types';

const { Text } = Typography;

export interface GxPDefaultTab {
  id: GxPReportTabKey;
  label: string;
}

interface Props {
  tab: GxPDefaultTab;
  isActive: boolean;
  recordCount?: number;
  onClick: () => void;
}

const DefaultTabItem: React.FC<Props> = ({
  tab,
  isActive,
  recordCount,
  onClick,
}) => {
  return (
    <div
      data-testid={`gxp-default-tab-${tab.id}`}
      role='tab'
      aria-selected={isActive}
      onClick={onClick}
      className={`gxp-tab-item${isActive ? ' gxp-tab-item--active' : ''}`}
    >
      <Text className='gxp-tab-item-ellipsis'>{tab.label}</Text>
      {recordCount !== undefined && (
        <span className='gxp-badge-wrapper'>
          <Badge count={recordCount} overflowCount={9999} />
        </span>
      )}
    </div>
  );
};

export default DefaultTabItem;
